import { useCallback } from 'react';
import { useSettingsStore } from '@/store';

type HapticPattern = number | number[];

export function useHaptics() {
    const { audioMode } = useSettingsStore();

    const trigger = useCallback((pattern: HapticPattern) => {
        if (audioMode === 'off') return;

        // Check for hardware support
        if (typeof navigator !== 'undefined' && navigator.vibrate) {
            navigator.vibrate(pattern);
        }
    }, [audioMode]);

    // Predefined patterns
    const patterns = {
        success: 50,
        warning: 200,
        error: [50, 50, 50],
        light: 10,
        medium: 20,
        heavy: 40,
        tick: 5,
    };

    return { trigger, patterns };
}
